exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-color-picker span.color-picker-box {\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  margin-bottom: -6px;\n  border: 1px solid white;\n}\n.btn-color-picker.btn-sm span.color-picker-box {\n  width: 18px;\n  height: 18px;\n  margin-bottom: -3px;\n}\n.fill-color-picker {\n  position: absolute;\n  z-index: 999;\n}\n.vc-chrome {\n  border: 1px solid #ccc;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075) !important;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075) !important;\n}\n.single-element-container {\n  display: inline;\n}\n", ""]);

// exports
